import * as AddressSelectorActions from '../actions/address-selector.actions';

export interface AddressSelectorState {
  selectedAddress: any;
}

export const initialState: AddressSelectorState = {
  selectedAddress: undefined,
};

export function reducer(
  state: AddressSelectorState = initialState,
  action: AddressSelectorActions.Actions,
): AddressSelectorState {
  switch (action.type) {
    case AddressSelectorActions.SELECT_ADDRESS:
      return {
        ...state,
        selectedAddress: action.payload,
      };
    default:
      return state;
  }
}

export const getSelectedAddress = (state: AddressSelectorState) =>
  state.selectedAddress;
